<template>

  <v-container
    grid-list-md>
    <Banner/>
    <v-layout
      row
      wrap
      justify-end
    >
      <v-flex xs12>
        <v-tabs v-model="tabFuncionalidade">
          <v-tab><v-icon>mdi-nutrition</v-icon>{{ strings[idioma].tabela_resumida }}</v-tab>
          <v-tab><v-icon>mdi-corn</v-icon>{{ strings[idioma].meus_alimentos }}</v-tab>
        </v-tabs>
      </v-flex>
      <v-flex v-if="tabFuncionalidade === 0">
        <TabelaResumida/>
      </v-flex>
      <template v-if="tabFuncionalidade === 1">
        <v-flex
          v-if="getAcessoModulo({ user: user, modulo: LISTAR_ALIMENTOS_USUARIO }) && alimentosUsuario && alimentosUsuario.length > 0"
          :xs12="alimentosUsuario">
          <material-card

            color="indigo lighten-5 font-weight-bold">
            <v-text-field
              :label="strings[idioma].pesquisar"
              v-model="searchAlimentos"
              flat

              hide-details
              clearable
              append-icon="mdi-magnify"
              clear-icon="mdi-close"/>
            <v-divider/>
            <v-tabs v-model="tab">
              <v-tab v-show="getAcessoModulo({ user: user, modulo: LISTAR_ALIMENTOS_USUARIO }) || (user.emp_user && user.emp_user.acesso === 0) || user.permissao === 0">{{ strings[idioma].privado }}</v-tab>
              <v-tab v-show="(user.empresa_vinculada && user.empresa_vinculada.length > 0 && user.emp_user && user.emp_user.acesso === 0) || user.permissao === 0">{{ strings[idioma].empresa }}</v-tab>
              <v-tab v-show="getAcessoModulo({ user: user, modulo: ENVIAR_ALIMENTO_ADAPTADO })">{{ strings[idioma].adaptado }}</v-tab>
            </v-tabs>
            <div
              v-if="categorias_alimentos && categorias_alimentos !== null"
              style="padding: 0; margin: 0; max-height: 200px; width: 100%; overflow:auto;">
              <v-list
                v-for="us in alimentosFilter"
                :key="us.id"
                :style="us.EXCLUIDO === 1 ? 'opacity: 0.6;': null"
                dense
                flat
                rounded>
                <v-list-tile
                  flat
                  @click="(remove && !copiar) ? removeAlimento(us) : (!copiar) ? openAlimento(us) : null">
                  <v-list-tile-avatar>
                    <v-icon
                      v-text="'mdi-nutrition'"
                    />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ (us.empresa && us.empresa.nome) ? us.empresa.nome + ' - ' : '' }}{{ us.nome }} - <i>{{ us.nome_cientifico }}</i>
                      &nbsp;
                      <template v-if="us.cliente && us.cliente !== null">
                        <b>({{ us.id_cliente === null ? strings[idioma].base_pessoal : us.cliente.nome }})</b>
                      </template>
                      <template v-else>
                        <b>({{ (us.publico) ? strings[idioma].publico: (us.id_empresa) ? strings[idioma].livre_acesso_empresa : strings[idioma].base_pessoal }})</b>
                      </template>
                    </v-list-tile-title>
                    <v-list-tile-sub-title v-if="us.id_tipo && us.id_tipo !== null">{{ tipos.filter(c=>c.id === us.id_tipo)[0][(idioma === 0) ? 'nome' : (idioma === 1) ?'nome_ingles' : 'nome_espanhol'] }} <span v-if="((!us.publico && !us.id_empresa) && (user.emp_user && user.emp_user.acesso === 0))"> - <a
                      small
                      @click="copiar = true; copiarAlimentoParaEmpresa(us)">{{ strings[idioma].transformar_alimento_empresa }}</a></span>

                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      flat
                      color="error"
                      small
                      @click="remove = true"> X </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </div>
          </material-card>

        </v-flex>
        <v-flex v-else>
          <p>{{ strings[idioma].cqbal_info_legal }}</p>
        </v-flex>
      </template>
    </v-layout>
  </v-container>

</template>
<script>
import { mapState } from 'vuex'
import { getAlimentosEmpresa, updateData, createMD5, getAlimentos } from '@/utils/utils'
import { LISTAR_ALIMENTOS_USUARIO, ENVIAR_ALIMENTO_ADAPTADO } from '@/utils/types'
import {
  replaceSpecialChars
} from '@/utils/vuex'
import Banner from '../components/Banner'
import TabelaResumida from '../TabelaResumida'

export default {
  components: {
    Banner,
    TabelaResumida
  },
  data: () => ({
    LISTAR_ALIMENTOS_USUARIO: LISTAR_ALIMENTOS_USUARIO,
    ENVIAR_ALIMENTO_ADAPTADO: ENVIAR_ALIMENTO_ADAPTADO,
    tab: 2,
    tabFuncionalidade: 0,
    tabsEnum: ['privados', 'empresa', 'adaptado'],
    alimentoBase: null,
    etapaAlimentoBase: true,
    alimento: {
      nome: '',
      nome_sci: '',
      tipo: null,
      nutrientes: {},
      user: {}
    },
    step: 1,
    loadingAlimentos: false,
    escolha: false,
    basePessoal: false,
    stepComplete: [false, false],
    alimentosUsuario: [],
    alimentoClick: [],
    arrayTable: [
      {
        id: 'ok'
      }
    ],
    calculandoDieta: false,
    calculandoNutrientes: false,
    changeMinMax: false,
    dialogNutrientes: false,
    dietaOtimizada: false,
    dietaSemiOtima: false,
    editarExigencias: false,
    loadingStep2: false,
    indexAlimentoDialog: 0,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    open: [],
    pagination: {
      rowsPerPage: 20,
      sortBy: null,
      descending: false,
      page: 1,
      totalItems: 0
    },
    recalculandoExigencias: false,
    search: null,
    searchRestricao: null,
    fixaVC: false,
    treeAlimentos: [],
    validAnimal: false,
    selected: false,
    indetermined: false,
    volumososSelecionados: [],
    concentradoSelecionados: [],
    selecionaComuns: false,
    expandeArvore: false,
    travaSelectAll: false,
    info: false,
    searchAlimentos: null,
    clientes: []
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'empresa', 'acesso_premium', 'alimentos_empresa', 'tipos']),

    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    selectable () {
      return this.open.length > 0
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 120) + 'px; overflow: auto;'
    },
    alimentosFilter () {
      let als = this.alimentosUsuario
      switch (this.tabsEnum[this.tab]) {
        case 'privados':
          als = als.filter(a => a.id_empresa === null && a.id_alimento_pai === null)
          break
        case 'empresa':
          als = als.filter(a => a.id_empresa !== null && a.id_alimento_pai === null)
          break
        case 'adaptado':
          als = als.filter(a => a.id_alimento_pai !== null && a.id_empresa === null)
          break
        default:
          als = als.filter(a => a.id_empresa === null && a.id_alimento_pai === null)
          break
      }
      if (this.searchAlimentos === null || this.searchAlimentos.trim() === '') return als
      let cliente = localStorage.getItem('cliente')
      let clienteID = null
      if (cliente !== null) {
        cliente = JSON.parse(cliente)
        clienteID = parseInt(cliente.id)
      }
      // if (clienteID !== null) als = als.filter(a => a.id_cliente === null || a.id_cliente === clienteID)
      als = als.filter(p => new RegExp(replaceSpecialChars(this.searchAlimentos.toLowerCase()), 'i').test(p.id + '-' + p.nome + '-' + p.nome_ingles + '-' + p.nome_espanhol) && p.nome !== null && String(p.nome).trim() !== '' && !p.EXCLUIDO)
      return als
    }
  },
  watch: {
    'tab' (val) {
      let al = JSON.stringify(this.alimentosUsuario)
      this.alimentosUsuario = []
      this.alimentosUsuario = JSON.parse(al)
    },
    'alimentoClick' (val) {
      this.alimentoBase = val
    },
    'loadingAlimentos' (val) {
      let loading = val
      this.$store.commit('setLoading', loading)
    },
    'treeAlimentos' (val) {
      if (Math.abs(this.alimentos_selecionados.length - val.length) > 2) {
        this.treeAlimentos = this.alimentos_selecionados
        return
      }
      this.$store.commit('setAlimentosSelecionados', val)
      this.pagination.totalItems = this.alimentos_selecionados.length
      this.stepComplete[0] = val.length !== 0
    },
    'open' (val) {
      if ((this.search === '' || this.search === null) && val.length > 1) {
        this.open = [val[val.length - 1]]
      }
    }
  },
  created () {
    this.$store.dispatch('getTipos')
    this.escolha = this.getAcessoModulo({ user: this.user, modulo: LISTAR_ALIMENTOS_USUARIO })
    this.loadAlimentosDieta()
    if (!this.$store.state.app.categorias_alimentos) {
      this.loadingAlimentos = true
      this.axios.post('alimentos/lastUpdateAt', {}).then(response => {
        this.getClientes()
        let lastUpdate = parseInt(response.data.data[1])
        if (lastUpdate === parseInt(localStorage.getItem('lastUpdate'))) {
          let tipos = JSON.parse(localStorage.getItem('tipos'))
          let alimentos = JSON.parse(localStorage.getItem('alimentos'))
          this.$store.commit('setAlimentos', { tipos: tipos, alimentos: alimentos })
          this.loadingAlimentos = false
        } else {
          this.axios.post('tipos', {}).then(response => {
            let tipos = response.data.data
            localStorage.setItem('tipos', JSON.stringify(tipos))
            this.axios.post('relatorio/alimentosBrCorte', {}).then(response => {
              localStorage.setItem('alimentos', JSON.stringify(response.data.data))
              this.$store.commit('setAlimentos', { tipos: tipos, alimentos: response.data.data })
              this.loadingAlimentos = false
              localStorage.setItem('lastUpdate', lastUpdate)
            }).catch(error => {
              console.log(error)
            })
          })
        }
      })
    }
    let meusAlimentos = []
    let cliente = localStorage.getItem('cliente')
    if (cliente !== null) {
      cliente = JSON.parse(cliente).id
    }
    this.axios.post('alimentos/getAlimentosUsuario', { id_pessoa: this.user.id }).then((res) => {
      for (let al of res.data.data) {
        let alim = Object.assign({}, al)
        alim['nutrientes'] = JSON.parse(al.nutrientes)
        meusAlimentos.push(alim)
      }
      this.alimentosUsuario = meusAlimentos
      this.$store.commit('setAlimentosUsuario', { alimentos: meusAlimentos })

      if ((this.user.empresa_vinculada && this.user.empresa_vinculada.length > 0 && this.user.emp_user && this.user.emp_user.acesso === 0)) {
        this.tab = 2
        getAlimentosEmpresa(this.$store.state, this.empresa.id, this.axios, true).then(r => {
          if (meusAlimentos.length === 0) this.tab = 1
          for (let al of this.alimentos_empresa) {
            this.alimentosUsuario.push(al)
          }
        })
      } else {
        if (meusAlimentos.length === 0) this.tab = 2
        else this.tab = 0
      }
    })
  },
  methods: {
    getClientes () {
      if (!this.user.consultoria || !this.user.consultoria.id) return null
      return this.axios.post('consultoria/clientes', { id: this.user.consultoria.id }).then(r => {
        this.clientes = r.data.data
        return this.clientes
      })
    },
    async loadAlimentosDieta () {
      this.loadingAlimentos = true
      this.loadingStep1 = true

      getAlimentos(this.$store, this.axios).then(r => {
        this.loadingAlimentos = false
        this.loadingStep1 = false
        // this.loadData()
      }).catch((e) => {
        this.loadingAlimentos = false
        this.loadingStep1 = false
        // this.loadData()
      })
    },
    go (url) {
      window.location.href = url
    },
    mudarEmpresa () {
      sessionStorage.removeItem('empresaAdm')
      this.go('/empresa')
    },
    enviarEmpresa () {
      sessionStorage.removeItem('empresaAdm')
      sessionStorage.removeItem('alimentoCarregado')
      this.go('/empresa/add-alimento')
    },
    resetAlimento () {
      this.alimento = {
        nome: '',
        nome_sci: '',
        tipo: null,
        nutrientes: {},
        user: {}
      }
    },
    copiarAlimentoParaEmpresa (al) {
      let alimento = Object.assign({}, al)
      alimento.nome_sci = alimento.nome_cientifico
      alimento.tipo = alimento.id_tipo
      alimento.id_empresa = this.user.emp_user.id_empresa
      alimento.empresa = this.user.empresa_vinculada
      for (let nut in alimento.nutrientes) {
        alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
      }
      alimento.id = null
      delete (alimento.id)
      this.alimento = alimento
      this.stepComplete[0] = true
      this.step = 2
      this.basePessoal = true
      sessionStorage.setItem('alimentoCarregado', JSON.stringify(alimento))
      window.location.href = '/empresa/add-alimento'
    },
    openAlimento (al) {
      let alimento = Object.assign({}, al)
      alimento.nome_sci = alimento.nome_cientifico
      alimento.tipo = alimento.id_tipo
      if (typeof alimento.nutrientes === 'string') {
        alimento.nutrientes = JSON.parse(alimento.nutrientes)
      }
      for (let nut in alimento.nutrientes) {
        if (alimento.nutrientes_raw) {
          alimento.nutrientes_raw[nut] = parseFloat(parseFloat(alimento.nutrientes[nut]).toFixed(2).replace(this.strings[this.idioma].separador_float, '.'))
        }
        alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
      }

      this.alimento = alimento
      this.stepComplete[0] = true
      this.step = 2
      this.basePessoal = true
      sessionStorage.setItem('alimentoCarregado', JSON.stringify(alimento))
      if (this.user.permissao === 0 && alimento.id_empresa && this.user.empresa_vinculada) sessionStorage.setItem('empresaAdm', JSON.stringify(this.user.empresa_vinculada[0]))
      if (alimento.id_empresa && alimento.id_empresa !== null) {
        sessionStorage.setItem('id_empresa', alimento.id_empresa)
        window.location.href = '/empresa/add-alimento'
      } else if (alimento.id_alimento_pai && alimento.id_alimento_pai !== null) window.location.href = '/enviar-alimento/adaptar'
      else window.location.href = '/enviar-alimento/privado'
    },
    removeAlimento (al) {
      delete this.remove
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.axios.post('alimentos/removeAlimento', { id: al.id }).then((res) => {
          let meusAlimentos = []
          this.axios.post('alimentos/getAlimentosUsuario', { id_pessoa: this.user.id }).then((res) => {
            for (let al of res.data.data) {
              let alim = Object.assign({}, al)
              alim['nutrientes'] = JSON.parse(al.nutrientes)
              meusAlimentos.push(alim)
            }
            this.alimentosUsuario = meusAlimentos
            // this.$store.commit('setAlimentosUsuario', { alimentos: meusAlimentos })
          })
        }).catch(() => alert('Erro, ao remover o alimento!!!'))
      }
    },
    changeIngrediente (ingrediente, nutriente, unidade) {
      let val = this.parseString(nutriente, this.idioma)
      this.alimento.nutrientes[ingrediente] = isNaN(this.alimento.nutrientes[ingrediente]) ? 0 : this.alimento.nutrientes[ingrediente]

      if (unidade === '%') {
        this.alimento.nutrientes[ingrediente] = (this.idioma === 0 || this.idioma === 2) ? (val > 100 ? 100 : (val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : (val > 100 ? 100 : (val < 0) ? 0 : val).toFixed(2).replace('.', ',')
      } else {
        this.alimento.nutrientes[ingrediente] = (this.idioma === 0 || this.idioma === 2) ? ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace('.', ',')
      }
      return this.alimento.nutrientes[ingrediente]
    },
    parseString (valor, idioma) {
      if ((idioma === 0 || idioma === 2) && valor && valor !== '-') {
        if (valor[valor.length - 3] === '.') return parseFloat(valor)
        return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (valor && valor !== '-') {
        return parseFloat(valor.replace(/[,]/g, ''))
      }
      return 0
    },
    enviaBasePessoal () {
      let assert = this.alimento.nome.length >= 3 && this.alimento.tipo !== null
      if (!assert) {
        let msg = this.strings[this.idioma].campos_faltantes + ((this.alimento.nome.length < 3) ? '\n O alimento deve ter no mínimo 3 caracteres!!!' : '')
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        let title = this.strings[this.idioma].atencao_erro
        this.$store.commit('openOKModal', {
          title,
          msg,
          error: true
        })

        return
      }
      this.alimento.user = this.user
      this.alimento.id_pessoa = (this.alimento.id_pessoa) ? this.alimento.id_pessoa : this.user.id
      this.alimento.nome_ingles = this.alimento.nome_espanhol = this.alimento.nome
      this.alimento.nome_cientifico = this.alimento.nome_sci
      // this.alimento.id_empresa = this.empresa.id
      delete this.alimento.nome_sci
      delete this.alimento.nutrientes_raw
      this.alimento.id_tipo = this.alimento.tipo
      let nutrientes = Object.assign({}, this.alimento.nutrientes)
      for (let ingredienteID in this.ingredientes) {
        let ingrediente = this.ingredientes[ingredienteID]
        if (!nutrientes[ingrediente.id]) nutrientes[ingrediente.id] = '0'
        nutrientes[ingrediente.id] = parseFloat(String(nutrientes[ingrediente.id]).replace(this.strings[this.idioma].separador_float, '.'))
      }
      this.alimento.nutrientes = JSON.stringify(nutrientes)
      delete this.alimento.tipo
      delete this.alimento.user
      delete this.alimento.empresa
      this.axios.post('empresa/addAlimento', { alimento: this.alimento }).then((res) => {
        let msg = this.strings[this.idioma].cadastrado
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        window.location.go(0)
      }).catch((err) => {
        console.log(err)
      })
    }
  }

}
</script>
